import getCDNURL from '@pickleballinc/ui/components/global/utils/getCDNURL';

interface AssociationsItems {
	websiteUrl: string;
	name?: string;
	logo: string;
}

interface TopPageAssociationsProps {
	associations: AssociationsItems[];
}

export const TopPageAssociations = ({ associations }: TopPageAssociationsProps) => {
	return (
		<div className=" bg-white">
			<div className="no-scrollbar mx-auto flex h-full min-h-[70px] max-w-screen-2xl flex-row gap-12 overflow-x-auto px-4 md:justify-between md:gap-3 xl:overflow-x-visible">
				{associations.map((item, index) => (
					<div key={index} className="flex flex-col items-center justify-center">
						<img
							src={
								item.logo
									? getCDNURL(item.logo, 100, 44)
									: `${process.env.NEXT_PUBLIC_IMAGE_CDN}/placeholder/pickleball_transparent_square.png`
							}
							alt="Logo"
							className="h-11"
						/>
						<span className="text-center">{item.name}</span>
					</div>
				))}
			</div>
		</div>
	);
};
